import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { Client } from '../../models/client.model';
import { EventRoadService } from '../../services/eventRoad.service';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { ShowerrordialogComponent } from '../showerrordialog/showerrordialog.component';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ClientService } from '../../services/client.service';
import { Roadbook } from 'src/app/models/roadbook.model';
import { Observable } from 'rxjs';
import { RoadbookSelectorComponent } from '../roadbook-selector/roadbook-selector.component';

@Component({
  selector: 'app-clients-page',
  templateUrl: './clients-page.component.html',
  styleUrls: ['./clients-page.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ClientsPageComponent implements OnInit {
  panelOpenState = false;
  newclientform: FormGroup;
  clients: Client[] = [];
  expandedElement: Client | null;
  displayedColumns: string[] = ['star', 'name', 'code', 'visible' ];
  dataSource: MatTableDataSource<Client>;
  filteredClients: Observable<any>;
  roadbooks: Roadbook[];
  editingClient: Client = null;
  currentRoadbooksIds = [];
  roadbooksDict = {};
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private formBuilder: FormBuilder,
    private roadbookProvider: EventRoadService,
    private clientProvider: ClientService,
    public dialog: MatDialog) {
    this.newclientform = this.formBuilder.group({
      name: [null, Validators.required],
      code: [null, null],
      visible: [true, null]
    });
   }

  ngOnInit(): void {
    this.roadbookProvider.getAll().subscribe(data => {
      this.roadbooks = data;
      this.roadbooksDict = {};
      data.forEach(di => this.roadbooksDict[di.id] = di);
      this.clientProvider.getAll().subscribe(clients => {
        this.clients =  clients;
        this.dataSource = new MatTableDataSource(this.clients);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  saveClient() {
    const errors = this.ValidateForm();
    if (errors.length === 0) {
      const eventRoad = this.getClientFromForm();
      if (this.editingClient) {
        eventRoad.i = this.editingClient.i;
        this.clientProvider.edit(eventRoad);
        this.editingClient = null;
      } else {
        const result = this.clientProvider.create(eventRoad);
      }
      this.reset();
    } else {
      const dialogRef = this.dialog.open(ShowerrordialogComponent, { data: errors });
    }
  }

  editElemet(element) {
    this.editingClient = element;
    this.newclientform.controls['name'].setValue(this.editingClient.n);
    this.newclientform.controls['code'].setValue(this.editingClient.c);
    this.newclientform.controls['visible'].setValue(this.editingClient.v);
    this.currentRoadbooksIds = this.editingClient.r ? this.editingClient.r : [];
    this.panelOpenState = true;
    window.scroll(0, 0);
  }
  removeElemet(element) {
    this.clientProvider.remove(element);
  }
  getClientFromForm() {
    const visible = this.newclientform.controls['visible'].value;
    const roadbooks = this.currentRoadbooksIds;
    return new Client('',
      this.newclientform.controls['name'].value,
      this.newclientform.controls['code'].value,
      roadbooks,
      visible);
  }
  changeCheckBox(row, event) {
    this.clientProvider.editVisible(row, event.checked);
  }

  ValidateForm() {
    const errors = [];
    if (!this.newclientform.controls['name'].value) { errors.push('Cal indicar el nom del Roadbook'); }
    if (!this.newclientform.controls['code'].value) { errors.push(`Cal indicar el codi d'accés del client`); }
    return errors;
  }
  reset() {
    this.currentRoadbooksIds = [];
    this.newclientform.reset();
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(RoadbookSelectorComponent, {
      width: '60%',
      data: { roadbooks_ids: this.currentRoadbooksIds }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.currentRoadbooksIds = result;
        if (this.editingClient) {
          this.editingClient.r = result;
        }
      }
    });
  }
}
